const NATIVE_APP_STORAGE_KEY = "knackNativeApp";
const NATIVE_APP_UA_TOKEN = /KnackMobileApp|GalaxyMobileApp/i;

const getNativeAppQueryValue = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    return (
      params.get("source") ||
      params.get("from") ||
      params.get("client") ||
      ""
    ).toLowerCase();
  } catch (error) {
    return "";
  }
};

const hasExplicitNativeAppSignal = (ua) => {
  const queryValue = getNativeAppQueryValue();
  const fromQuery =
    queryValue === "app" ||
    queryValue === "mobile-app" ||
    queryValue === "native";
  const fromUa = NATIVE_APP_UA_TOKEN.test(ua || "");
  const fromBridge = Boolean(
    window.ReactNativeWebView ||
      window.KnackNativeApp ||
      window.GalaxyNativeApp
  );

  return fromQuery || fromUa || fromBridge;
};

export const checkIsMobileDevice = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  const isMobileUA = /android|iphone|ipad|ipod|windows phone/i.test(
    ua.toLowerCase()
  );

  const isTouchDevice =
    "ontouchstart" in window || navigator.maxTouchPoints > 0;
  const isNotDevTools = !navigator.webdriver;

  const isSmallScreen = window.innerWidth <= 768;

  return isMobileUA && isTouchDevice && isNotDevTools && isSmallScreen;
};

export const isDeviceIos = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

  return isIOS;
};

export const isNativeMobileApp = () => {
  if (typeof window === "undefined") {
    return false;
  }

  const ua = navigator.userAgent || navigator.vendor || window.opera || "";

  if (hasExplicitNativeAppSignal(ua)) {
    try {
      sessionStorage.setItem(NATIVE_APP_STORAGE_KEY, "1");
    } catch (error) {
      // Ignore storage failures in private / restricted WebViews.
    }
    return true;
  }

  try {
    if (sessionStorage.getItem(NATIVE_APP_STORAGE_KEY) === "1") {
      return true;
    }
  } catch (error) {
    // Fall through to UA heuristics.
  }

  const isAndroidWebView = /Android/i.test(ua) && /; wv\)/i.test(ua);
  const isIosWebView =
    /iPhone|iPad|iPod/i.test(ua) &&
    /AppleWebKit/i.test(ua) &&
    !/Safari/i.test(ua);

  return isAndroidWebView || isIosWebView;
};
